<template lang="">
  <div data-cy="tournament-card-container">
    <v-card
      :color="useDetectedColor ? color : undefined"
      :to="{ name: 'event', params: { tournamentId: tournament.id } }"
      data-cy="tournament-card-link"
    >
      <v-img
        :src="banner"
        height="200px"
        cover
        data-cy="tournament-banner"
        @load="loadPalette"
      ></v-img>
      <div class="d-flex">
        <div class="d-flex flex-column w-100">
          <v-card-title data-cy="tournament-name">
            {{ tournament.name }}
          </v-card-title>
          <v-card-text class="w-100 d-flex justify-space-between">
            <div class="d-flex flex-column">
              <div data-cy="tournament-dates">
                <v-icon>mdi-calendar</v-icon>
                {{ startDate }} {{ startDate === endDate ? '' : `- ${endDate}` }}
              </div>
              <div v-if="tournament.isOnline" data-cy="tournament-online-status">
                <v-icon>mdi-wifi</v-icon>
                Online
              </div>
              <div v-else data-cy="tournament-location">
                <v-icon>mdi-map-marker</v-icon>
                {{ tournament.city }}, {{ tournament.countryCode }}
              </div>
            </div>
            <div class="d-flex flex-column">
              <div data-cy="tournament-attendees">
                <v-icon>mdi-account</v-icon>
                {{ tournament.numAttendees }} Attendees
              </div>
              <div data-cy="tournament-events">
                <v-icon>mdi-card-multiple</v-icon>
                {{ tournament.events.length }} Events
              </div>
            </div>
          </v-card-text>
        </div>
      </div>
    </v-card>
  </div>
</template>
<script>
import { format } from 'date-fns'
import * as Vibrant from 'node-vibrant'
import { useTheme } from 'vuetify'

export default {
  props: {
    tournament: {
      type: Object,
      required: true
    },
    useDetectedColor: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  setup() {
    let { current } = useTheme()

    return { current }
  },
  data: function () {
    return {
      palette: null
    }
  },
  computed: {
    banner() {
      return this.tournament?.images?.find((image) => image.type === 'banner')?.url || ''
    },
    startDate() {
      return format(new Date(this.tournament.startAt * 1000), 'MMM d, yyyy')
    },
    endDate() {
      return format(new Date(this.tournament.endAt * 1000), 'MMM d, yyyy')
    },
    color() {
      return this.current.dark ? this.palette?.DarkVibrant.hex : this.palette?.LightVibrant.hex
    }
  },
  methods: {
    loadPalette() {
      if (!this.banner || !this.useDetectedColor) {
        return
      }
      Vibrant.from(this.banner)
        .getPalette()
        .then((palette) => {
          this.palette = palette
        })
        .catch(() => {
          this.palette = null // Reset palette on error
        })
    }
  }
}
</script>

<style lang=""></style>
